import Image from 'next/image'
import Sheet from 'react-modal-sheet'
import styled from 'styled-components'

import ICandidato from '@/app/2023/consejo/types/ICandidato'
import { spaces } from '@/config/global-parameters'

interface ISheetBase {
  className?: string
  candidato?: ICandidato
  onClose: () => void
  children?: React.ReactNode
}

const SheetBase = ({ candidato, children, className, onClose }: ISheetBase) => (
  <Sheet
    className={className}
    detent="content-height"
    isOpen={Boolean(candidato)}
    onClose={onClose}
  >
    <Sheet.Container>
      <Sheet.Header />
      <Sheet.Content>
        <Wrapper>
          <Close
            alt="close"
            height={18}
            onClick={onClose}
            src="/icons/close.svg"
            width={18}
          />
          {children}
        </Wrapper>
      </Sheet.Content>
    </Sheet.Container>
    <Sheet.Backdrop onTap={onClose} />
  </Sheet>
)

const Wrapper = styled.div`
  display: flex;
  padding: 0 ${spaces.l} ${spaces.m} ${spaces.l};
`

const Close = styled(Image)`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: ${spaces.s};
`

export default SheetBase
